<template>
  <div class="container-fluid">
    <main-header v-if="currentStep !== 'point-agree'"></main-header>
    <!-- 본인인증 -->
    <social-login-validation @current-page="receiveData" v-if="currentStep === 'intro'"></social-login-validation>
    <!-- 화물맨 / 아틀란 -->
    <join-hmm @current-page="receiveData" v-if="currentStep === 'hmm'"></join-hmm>
    <join-atl @current-page="receiveData" v-if="currentStep === 'atl'"></join-atl>
    <join-event20 @current-page="receiveData" v-if="currentStep === 'event20'"></join-event20>
    <!-- 기본 완료 화면 -->
    <completion-screen-default @current-page="receiveData" v-else-if="currentStep === 'default-completion'"></completion-screen-default>
    <!-- 서류 제출 -->
    <member-paper-attach @current-page="receiveData" v-else-if="currentStep === 'att'"></member-paper-attach>
    <!-- 첨부 완료 화면 -->
    <completion-screen-attach @current-page="receiveData" v-else-if="currentStep === 'attach-completion'"></completion-screen-attach>
    <!-- 회원 정보 입력 화면(25-03-20) -->
    <member-simple @current-page="receiveData" v-else-if="currentStep === 'member-final'"></member-simple>
    <!-- 회원 정보 입력 화면(25-03-19) -->
    <member-info-new @current-page="receiveData" v-else-if="currentStep === 'member-info'"></member-info-new>
    <!-- 회원 정보 입력 화면(25-03-21) -->
    <member-simple-v2 @current-page="receiveData" v-else-if="currentStep === 'member-final-v2'"></member-simple-v2>
    <!-- 첨부서류 3종 화면(25-03-19) -->
    <member-paper-attach-new @current-page="receiveData" v-else-if="currentStep === 'member-paper'"></member-paper-attach-new>
    <!-- 첨부 완료 화면 -->
    <member-final-fin @current-page="receiveData" v-else-if="currentStep === 'member-completion'"></member-final-fin>
  </div>
</template>

<script>
import JoinHmm from "@/views/join/JoinHmm.vue";
import CompletionScreenDefault from "@/views/CompletionScreenDefault.vue";
import MemberPaperAttach from "@/views/link/MemberPaperAttach.vue";
import CompletionScreenAttach from "@/views/CompletionScreenAttach.vue";
import JoinAtl from "@/views/join/JoinAtl.vue";
import MainHeader from "@/views/MainHeader.vue";
import SocialLoginValidation from "@/views/SocialLoginValidation.vue";
import JoinEvent20 from "@/views/join/JoinEvent20.vue";
import MemberPaperAttachNew from "@/views/any/MemberPaperAttachNew.vue";
import MemberInfoNew from "@/views/any/MemberInfoNew.vue";
import MemberSimple from "@/views/any/MemberSimple.vue";
import MemberFinalFin from "@/views/any/MemberFinalFin.vue";
import MemberSimpleV2 from "@/views/any/MemberSimpleV2.vue";

export default {
  name: "JoinSocialContainer",
  components: {
    MemberSimpleV2,
    MemberFinalFin,
    MemberSimple,
    MemberInfoNew,
    MemberPaperAttachNew,
    JoinEvent20,
    SocialLoginValidation,
    MainHeader,
    JoinAtl,
    JoinHmm,
    CompletionScreenAttach,
    MemberPaperAttach,
    CompletionScreenDefault,
  },
  data(){
    return {
      currentStep:this.$store.getters.getCurrentPage,
    }
  },
  methods:{
    receiveData(step){
      this.currentStep = step.page;
    },
  },

}
</script>

<style scoped>
</style>